<template><div class="page_content_allocation">
  <div class="page_content_header">
    <span>分配供应商</span>
    <!--  <i class="el-icon-close"></i>-->
  </div>
  <div class="page_content_title">分配供应商</div>
  <div class="descriptions">
    <div class="descriptions_title" style="font-size: 16px">
      {{detailshow.OrderNum?detailshow.OrderNum:"--"}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{detailshow.ProjectName?detailshow.ProjectName:"--"}}&nbsp;
    </div><!---->
    <div class="descriptions_item">
      <span class="descriptions_item_label">客户姓名：</span>
      <span class="descriptions_item_value">{{detailshow.Name?detailshow.Name:"--"}}</span>
    </div>
    <div class="descriptions_item">
      <span class="descriptions_item_label">客户手机号：</span>
      <span class="descriptions_item_value">{{detailshow.Phone?detailshow.Phone:"--"}}</span>
    </div>
    <div class="descriptions_item">
      <span class="descriptions_item_label">需求描述：</span>
      <span class="descriptions_item_value">{{detailshow.Requirement?detailshow.Requirement:"--"}}</span>
    </div>
    <div class="descriptions_item">
      <span class="descriptions_item_label">备注： </span>
      <span class="descriptions_item_value">{{detailshow.Notes?detailshow.Notes:"--"}}</span>
    </div>
    <div class="descriptions_item">
      <span class="descriptions_item_label">所选创意： </span>
      <div class="descriptions_creative">
        <div class="descriptions_creative_item" v-for="(v,key) in detailshow.GoodsInfo" :key="key">
          <img :src="require('@/assets/img/goods/'+v.CategoryKey+'/'+v.GoodsPics)"/>
          <div class="descriptions_creative_item_info">
            <span>{{v.GoodsName?v.GoodsName:"--"}}</span>
            <span>数量：&nbsp;{{v.GoodsCount?v.GoodsCount:"--"}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="descriptions_item">
      <span class="descriptions_item_label" style="line-height: 40px;"> <i class="input_prompt">*</i>接单服务商： </span>
      <span class="descriptions_item_value">
        <el-select v-model="service_userid" placeholder="请选择接单服务商" filterable>
          <el-option :key="item.userid" :label="item.company" :value="item.userid" v-for="(item) in order_taking_user_type" ></el-option>
        </el-select>
      </span>
    </div>
    <div class="descriptions_item">
      <span class="descriptions_item_label" style="line-height: 40px;"><i class="input_prompt">*</i>含税总价： </span>
      <span class="descriptions_item_value">
        <el-input style="width:280px" v-model="order_money" placeholder="请填写与供应商沟通后的含税总价"></el-input>
    </span>
    </div>
    <div class="botton_allocation">
      <el-button class="modal_content_btn_submit" @click="closeDingTalkPage()">取消</el-button>
      <el-button class="modal_content_btn_submit" type="primary" @click="submitForm()">下单</el-button>
    </div>
  </div>
</div>
</template>
<script>
/* eslint-disable */
// import dd from 'dingtalk-jsapi';
import * as commfun from "@/common/common.js"
export default {
  name: 'Placeorder',
  components: {
    // v_ajax,
    // vue
  },
  data() {
    return {
      name:"",
      orderId:"",
      corpId:"",
      detailshow: {
        OrderNum: "",
        ProjectName: "",
        Name: "",
        Phone: "",
        phone: "",
        notes:""
      },
      order_money:'',
      service_userid:'',
      order_taking_user_type:[],//接单服务商字典
    };
  },
  created() {
    document.documentElement.classList.add('special'); // 添加类名到html元素
    document.body.classList.add('special'); // 添加类名到body元素
  },
  destroyed() {
    document.documentElement.classList.remove('special'); // 移除类名
    document.body.classList.remove('special'); // 移除类名
  },
  methods:{
    getAuthCode() {
      var selfthis=this
      dd.runtime.permission.requestAuthCode({
        corpId: selfthis.corpId,
        onSuccess: function(result) {
          // 在这里处理成功获取到的免登授权码
          var url = "/api/api/dd/sign"
          commfun.ajaxPost(selfthis,url,{dd_code:result.code},function (selfthis,data){
            if (data){
              selfthis.name = data
              //获取字典数据
              selfthis.initdic();
              //获取详情数据
              selfthis.initAllDetail()
            }else{
              selfthis.tipDingTalkPage("错误提示","用户为空")
            }
          },function (selfthis,dataError){
            selfthis.tipDingTalkPage("错误提示",dataError.msg)
          })
        },
        onFail: function(error) {
          // 在这里处理获取免登授权码失败的情况
          selfthis.tipDingTalkPage("错误提示",error.errorCode)
        }
      });
    },
    //带弹框提示的关闭提示框
    tipDingTalkPage(title,msg){
      // 处理错误回调
      dd.device.notification.alert({
        message: msg,
        title: title,
        buttonName: '关闭',
        onSuccess: function () {
          // 对话框按钮点击事件
          dd.biz.navigation.close({
            onSuccess: function () {
              // 当前页面关闭成功
            },
            onFail: function () {
              // 当前页面关闭失败
            }
          });
        }
      });
    },
    //直接关闭钉钉界面
    closeDingTalkPage() {
      var selfthis=this
      dd.biz.navigation.close({
        onSuccess: function(result) {
          // 关闭钉钉页面成功的回调
        },
        onFail: function(error) {
          // 关闭钉钉页面失败的回调
        }
      });
    },
    //字典
    initdic: function() {
      var selfthis = this;
      var url = 'api/api/order/ajaxDict';
      commfun.ajaxPost(selfthis, url, {}, function (selfthis, result) {
        selfthis.order_status_type = result.order_status_type
        selfthis.order_taking_user_type = result.order_taking_user_type
      }, function (selfthis, result) {
        selfthis.tipDingTalkPage("错误提示",result.msg)
      })
    },
    initAllDetail:function (){
      var selfthis=this
      var id = selfthis.orderId
      var url = "/api/api/order/detail"
      commfun.ajaxPost(selfthis,url,{order_id:id},function (selfthis,data){
        selfthis.detailshow =data
        selfthis.order_money = selfthis.detailshow.OrderMoney
        if (selfthis.detailshow.ServiceUserid){
          selfthis.service_userid = selfthis.detailshow.ServiceUserid
        }
      },function (selfthis,dataError){
        selfthis.tipDingTalkPage("错误提示",dataError.msg)
      })
    },

    submitForm(){
      var selfthis=this
      var order_id =selfthis.orderId
      var order_money =selfthis.order_money
      var service_userid =selfthis.service_userid
      var url = "/api/api/order/allocation"
      if (!service_userid){
        commfun.showMessage(selfthis,'warning',"错误：请选择该项目的接单服务商")
        return false;
      }
      commfun.ajaxPost(selfthis,url,{order_id:order_id,order_money:order_money,name:selfthis.name,service_userid:service_userid},function (selfthis,data){
        selfthis.tipDingTalkPage("提示","保存成功")
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },

  },

  mounted: function() {
    // 定义要加载的 CSS 文件数组
    // const cssFiles = [
    //   import('@/assets/css/allocation.css'),
    //   import('@/assets/css/themeStyle/theme/index1.css'),
    // ];
    // // 执行多个异步加载任务并等待完成
    // Promise.all(cssFiles)
    //   .then(() => {
    //     // 所有 CSS 文件加载成功后的回调函数
    //     console.log('所有 CSS 文件加载成功');
    //   })
    //   .catch(error => {
    //     // 加载失败的回调函数
    //     console.error('CSS 文件加载失败', error);
    //   });

    var selfthis = this

    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    selfthis.orderId = urlParams.get('order_id');
    selfthis.corpId = urlParams.get('corp_id');
    // selfthis.initAllDetail()
    // //获取字典
    // selfthis.initdic();
    const script = document.createElement('script');
    script.src = 'https://g.alicdn.com/dingding/dingtalk-jsapi/3.0.25/dingtalk.open.js';
    script.onload = () => {
      // 脚本加载完成后，使用全局变量dd来访问dingtalk-jsapi提供的功能
      this.getAuthCode();
    };
    document.body.appendChild(script);
  },

}
</script>



// WEBPACK FOOTER //
// src/components/Allocation.vue